import React, { useContext } from 'react';

type HeaderContextProps = {
  closeMobileMenu?: () => void;
};

export const HeaderContext = React.createContext<HeaderContextProps>({});

export const useHeaderContext = () => useContext(HeaderContext);
